import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';

export class FoxpostTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    return this.http
      .get(`/api/translations`)
      .pipe(map((data: any) => data[lang]));
  }
}
export function createFoxpostTranslateLoader(
  http: HttpClient
): TranslateLoader {
  return new FoxpostTranslateLoader(http);
}
